var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 30,
    viewBox: "0 0 30 30",
    width: 30,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m20.982 4.65628c-1.0943-1.09431-2.9478-.73735-3.5574.6851l-1.9907 4.64504c-1.8739-.36747-3.8927.17388-5.3464 1.62748l-2.13759 2.1376c-.36612.3661-.36612.9597 0 1.3259l3.11909 3.1191-6.732 6.732c-.36612.3662-.36612.9597 0 1.3259.36611.3661.9597.3661 1.32582 0l6.73208-6.7321 3.1192 3.1193c.1758.1758.4143.2745.6629.2745.2487 0 .4871-.0987.6629-.2745l2.1376-2.1377c1.4537-1.4536 1.995-3.4725 1.6275-5.3463l4.6451-1.9907c1.4224-.6097 1.7794-2.4632.6851-3.55747zm-1.834 1.4237c.0871-.20321.3519-.2542.5082-.09788l4.9531 4.9532c.1564.1563.1054.4211-.0978.5082l-5.3942 2.3117c-.4554.1952-.6803.7111-.5134 1.1777.5138 1.4353.1946 3.0984-.9522 4.2452l-1.4747 1.4747-6.23835-6.2384 1.47475-1.4747c1.1467-1.1467 2.8098-1.4659 4.2452-.9522.4665.167.9824-.0579 1.1776-.5134z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPin);
export default __webpack_public_path__ + "static/media/icon_pin.e16d309b8c7405d566bd0eec16788611.svg";
export { ForwardRef as ReactComponent };